import React from 'react';
import EventChip from './EventChip';
import emptyThumbNail from '../../../assets/emptyThumbNail.svg';

const CurrentEvents = () => {
  return (
    <div id='events' className="flex flex-col items-start px-6 lg:px-[61px] pb-10 w-full">
      <div className="pt-4 px-[18px] bg-[#F6F7F9] rounded-lg pb-4 max-w-full">
        <div className="font-inter flex flex-col justify-start items-start gap-4 pb-8">
          <span className="font-bold text-[22px] text-[#000000]">Our Events</span>
          <span className="font-normal text-sm text-[#000000CC] text-justify">
            Welcome to the ACM Chapter at SJCE! Though we're in our early stages, we're excited to host events that promote learning, collaboration, and growth. As we grow, we'll organize workshops, hackathons, guest lectures, and networking events to help members enhance their skills and connect with industry professionals.
          </span>
        </div>
        <div className="flex flex-col gap-4">
          <EventChip
            eventName="ACM - The Inauguration function"
            eventDetail="The inauguration of the ACM Chapter at St. Joseph's college of engineering marks the start of an exciting journey to foster innovation and collaboration in tech. Join us as we celebrate the launch and kick off this new chapter!"
            eventThumbNail={emptyThumbNail}
          />
        </div>
      </div>
    </div>
  );
};

export default CurrentEvents;
